import { flexRender } from "@tanstack/react-table";
import type { Row } from "@tanstack/react-table";

import { tw } from "~/utils";
import { TableCell } from "./TableCell";
import { TableRow } from "./TableRow";

interface TableContentProps<TData> {
  rows: Row<TData>[];
  numColumns: number;
  onRowClick?: (row: TData) => void;
}

export const TableContent = <TData,>({
  rows,
  numColumns,
  onRowClick,
}: TableContentProps<TData>) => {
  if (!rows.length) {
    return (
      <TableRow className="hover:bg-neutral-variant-10">
        <TableCell colSpan={numColumns} className="hover:none py-4 text-center">
          No records found.
        </TableCell>
      </TableRow>
    );
  }

  return (
    <>
      {rows.map((row) => (
        <TableRow
          key={row.id}
          data-state={row.getIsSelected() && "selected"}
          onClick={() => onRowClick?.(row.original)}
          className={tw(
            onRowClick && "cursor-pointer transition-colors hover:bg-gray-50",
          )}
        >
          {row.getVisibleCells().map((cell) => {
            const meta = cell.column.columnDef.meta as
              { cellClassName?: string } | undefined;
            return (
              <TableCell
                key={cell.id}
                className={tw(
                  "cursor-pointer truncate",
                  cell.column.id === "actions" && "py-0",
                  meta?.cellClassName,
                )}
              >
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </TableCell>
            );
          })}
        </TableRow>
      ))}
    </>
  );
};
